@if (status_option) {
  <div class="status-widget">
    <span
        class="material-symbols-outlined status-icon {{status_option.status}}"
        aria-hidden="false"
        aria-label="{{status_option.description}}">
    {{status_option.icon}}</span>
    <p class="status-text">{{status_option.pretty_title}}</p>
  </div>
} @else {
  <p>Unknown Status</p>
}
